// Lets plugins/vue-sentry.js hand a chunk load error to the recovery logic in
// chunkLoadErrorHandler.js without importing it, which would pull i18n, the
// snackbar service, and @sentry/vue into the Sentry plugin's module graph and
// into its tests. Dependency-free on purpose.

let handler = null;

export function setChunkRecoveryHandler(fn) {
    handler = typeof fn === 'function' ? fn : null;
}

/**
 * Offer a chunk load error to recovery.
 *
 * @param {unknown} error
 * @returns {boolean} true when recovery has taken ownership of this failure
 *   (it reloaded, prompted, or already did so for the same error). Only then
 *   should the raw error be suppressed from user-facing handling and Sentry.
 */
export function recoverChunkError(error) {
    if (!handler) {
        return false;
    }

    try {
        return handler(error) === true;
    } catch (_error) {
        return false;
    }
}

export function resetChunkRecoveryBridge() {
    handler = null;
}
